export const Logo = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="17" fill="none" stroke="currentColor" strokeWidth="4" />
    <path d="M32 4v56" stroke="currentColor" strokeWidth="4" />
    <circle cx="32" cy="32" r="5" fill="#D4AF37" />
  </svg>
);

export const Brand = () => (
  <a href="/" data-testid="brand-home-link" className="flex items-center gap-3 text-chalk">
    <img src="/img/logo-usc.png" alt="Logo USC Jemappes" data-testid="club-logo-header" className="h-11 w-auto drop-shadow-md" />
    <span className="font-display text-2xl uppercase tracking-wide leading-none">USC Jemappes U12 C</span>
  </a>
);
